import { createSelector } from 'reselect'
import API from '../../../utils/http/api'
import fixtures from '../../../fixtures'

// Action Types
const REQUEST = 'steppingblocks/savedTuitionSearches/REQUEST'
const SUCCESS = 'steppingblocks/savedTuitionSearches/SUCCESS'
const FAILURE = 'steppingblocks/savedTuitionSearches/FAILURE'
const SAVE_SUCCESS = 'steppingblocks/savedTuitionSearches/SAVE_SUCCESS'
const DELETE_SUCCESS = 'steppingblocks/savedTuitionSearches/DELETE_SUCCESS'

// Reducer
const initialState = {
  error: null,
  requestStarted: false,
  requestEnded: false,
  results: [],
  pagination: fixtures.pagination,
}

export default (_state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case REQUEST:
      return {
        ..._state,
        error: null,
        requestStarted: true,
        requestEnded: false,
      }
    case SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        results: payload.results,
        pagination: payload.pagination,
      }
    case SAVE_SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        results: payload.result.concat(_state.results),
      }
    case DELETE_SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        results: _state.results.filter(item => item._id !== payload.id),
      }
    case FAILURE:
      return {
        ..._state,
        requestEnded: true,
        error: payload.error,
      }
    default:
      return _state
  }
}

// Action Performers
export const performRetrieveSavedTuitionSearches = params => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const data = await API.get(`/tuition/saved/${params.user_id}`, {})
    dispatch({
      type: SUCCESS,
      payload: {
        results: data.results,
        pagination: data.pagination,
      },
    })
    return data
  } catch (error) {
    dispatch({
      type: FAILURE,
      payload: { error: error.message },
    })
    return error
  }
}

export const performSaveTuitionSearch = params => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const data = await API.post('/tuition/save', params)
    dispatch({
      type: SAVE_SUCCESS,
      payload: {
        result: [data.result],
      }
    })
    return data
  } catch (error) {
    dispatch({
      type: FAILURE,
      payload: { error: error.message }
    })
    throw new Error(error)
  }
}

export const performDeleteSavedTuitionSearch = params => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    await API.del(`/tuition/save/${params.id}`)
    dispatch({
      type: DELETE_SUCCESS,
      payload: {
        id: params.id
      }
    })
  } catch (error) {
    dispatch({
      type: FAILURE,
      payload: { error: error.message }
    })
    throw new Error(error)
  }
}

// Selectors
const savedTuitionSearches = state => state.savedTuitionSearches

export const getSavedTuitionSearches = createSelector(savedTuitionSearches, data => data.results)



// WEBPACK FOOTER //
// ./src/routes/authenticated/Tuition/savedTuitionSearchesDuck.js